// eslint-disable-next-line @typescript-eslint/naming-convention
export default class advisor {
  constructor() {
    this.allAdvisors = [];
    this.moneyTransfers = [];
    this.workflows = [];
  }
}
